import React from "react";
import {observer} from "mobx-react";
import {FlightsDatesSelector} from "../../../services/flight-search/dates-selection/flights-dates-selector";
import {MonthModel} from "../../../services/time/month.model";
import {FlightCalendarMonthComponent} from "../flight-calendar-month.component";
import styled from "styled-components";
import {FlightDatesDropdownMobileHeaderComponent} from "../header/flight-dates-dropdown-mobile-header.component";
import {IDropDownController} from "../../drop-down/drop-down-controller.interface";

const ListContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    width: 100%;
    
`

const CalendarsContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: auto;
`


interface CalendarsInListComponentProps {
    flightsDatesSelector: FlightsDatesSelector;
    dropDownController: IDropDownController;
    onDateClicked: (date: Date) => void;
    renderMessages: () => React.ReactElement | null;
}
export const CalendarsInListComponent: React.FC<CalendarsInListComponentProps> = observer((props) => {
    const months = props.flightsDatesSelector.flightsScheduledMonths;


    const renderOneCalendar = (m: MonthModel) => {
        return (
            <FlightCalendarMonthComponent key={m.key} onDateClicked={props.onDateClicked} month={m} flightsDatesSelector={props.flightsDatesSelector}/>
        );
    }

    const renderCalendars = () => {
        const messages = props.renderMessages();
        if(messages) {
            return messages;
        }

        return (
            <>
                {months.map(renderOneCalendar)}
            </>
        )

    }

    return (
        <ListContainerBox>
            <FlightDatesDropdownMobileHeaderComponent datesSelector={props.flightsDatesSelector}
                                                      dropDownController={props.dropDownController}/>
            <CalendarsContainerBox>
                {renderCalendars()}
            </CalendarsContainerBox>
        </ListContainerBox>

    );
});
